const REVEAL_TARGETS = [
  '[id$="__trust_bar"] .section-content-wrapper > .group-block',
  '[id$="__categories"] .text-block',
  '[id$="__categories"] .layout-panel-flex--row > .group-block',
  '[id$="__categories"] .button',
  '[id$="__mission"] .text-block',
  '[id$="__faq"] .text-block',
  '[id$="__faq"] .accordion',
  '[id$="__contact_cta"] .text-block',
];

function reveal() {
  if (!('IntersectionObserver' in window)) return;

  const observer = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.setAttribute('data-usp-reveal', 'in');
        observer.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.05 }
  );

  for (const selector of REVEAL_TARGETS) {
    const elements = document.querySelectorAll(selector);
    elements.forEach((element, index) => {
      if (element.hasAttribute('data-usp-reveal')) return;
      element.setAttribute('data-usp-reveal', '');
      element.style.setProperty('--usp-reveal-delay', `${Math.min(index, 5) * 90}ms`);
      observer.observe(element);
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', reveal, { once: true });
} else {
  reveal();
}

// Section re-renders in the theme editor drop the attributes again.
document.addEventListener('shopify:section:load', reveal);
